<ion-header>
  <ion-toolbar>
    <ion-title>Gerät abmelden</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" [ngClass]="{'dark': (darkmode.isDarkMode | async ), 'light': !(darkmode.isDarkMode | async)}">

  <p style="opacity: 0.5;">
    Es sind bereits 3 Geräte mit Ihrem Benutzer-Account verknüpt. <br>
    Bitte wählen Sie ein Gerät aus, welches von Ihrem Account entfernt werden soll, um sich anzumelden.
  </p>
  <div class="item" [class.active]="item == activeLicense" *ngFor="let item of licenses" (click)="activeLicense = item">
    <div class="circle" *ngIf="item != activeLicense"></div>
    <svg *ngIf="item == activeLicense" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" class="svg-inline--fa fa-circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"></path></svg>
    <div>
      <h2>{{item.deviceDescription}}</h2>
      <h3>Angemeldet: {{item.date | timeFormat: "DD.MM.YYYY HH:mm:ss"}}</h3>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col size="6">
          <ion-button mode="ios" id="cancel" (click)="cancel()">Abbrechen</ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button mode="ios" id="release" (click)="submit()" [disabled]="!activeLicense">Entfernen </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
